// ========================================
// CONFIGURABLE CONSTANTS
// Easy to edit: texts, timing, season, etc.
// ========================================

// Email for mailto link
export const TARGET_EMAIL = 'edis@behyped.com';

// Season window for bookings (0-indexed: Jan=0, Mar=2, Oct=9)
// Extended to Jan-Dec for demo/testing, modify to 2-9 for real March-October season
export const SEASON_START_MONTH = 0; // January for demo (change to 2 for March)
export const SEASON_END_MONTH = 11;  // December for demo (change to 9 for October)

// Lead time: minimum 48 hours from now
export const MIN_LEAD_TIME_HOURS = 48;

// Tour duration (fixed)
export const TOUR_DURATION_HOURS = 3;

// Max people per boat type
export const MAX_PEOPLE = {
  rib: 12,
  exclusive: 9
};

// Boat type info
export const BOAT_TYPES = {
  rib: {
    id: 'rib',
    name: 'RIB Line',
    tagline: 'Gummi, aber zackig',
    subtitle: 'Gummi außen, Zack innen.',
    description: 'Länger als das andere, kann bis zu zwei Wellen gleichzeitig befahren.',
    benefits: ['Bis zu 250 PS', 'Sportlich & wendig', '2 Wellen gleichzeitig'],
    maxPeople: 12,
    emoji: '🚀'
  },
  exclusive: {
    id: 'exclusive',
    name: 'Exclusive Line',
    tagline: 'Mehr chill, mehr Komfort',
    subtitle: 'Sonnedeck & Komfort. Läuft.',
    description: 'Chillen mit Stil: Sonnendeck, Dusche, Stereoanlage, WC & bei manchen sogar Kajüte.',
    benefits: ['Sonnendeck', 'Dusche & WC', 'Stereoanlage', 'Kajüte möglich'],
    maxPeople: 9,
    emoji: '⛵'
  }
};

// Add-on options
export const ADDONS = [
  { id: 'wakeboard', name: 'Wakeboard', emoji: '🏄' },
  { id: 'ring', name: 'Ring', emoji: '🛟' },
  { id: 'none', name: 'Nix davo', emoji: '✌️' }
];

// Time slots
export const TIME_SLOTS = [
  { id: 'morning', label: '08:30 - 11:30', value: '08:30' },
  { id: 'midday', label: '12:30 - 15:30', value: '12:30' }
];

// Location options (Cyprus)
export const LOCATIONS = [
  { id: 'ayia-napa', name: 'Ayia Napa', description: 'Party-Hotspot im Osten', emoji: '🏖️' },
  { id: 'polis', name: 'Polis', description: 'Ruhig & idyllisch im Westen', emoji: '🌅' }
];

// Story panel texts (Badisch dialect)
export const STORY_PANELS = [
  {
    id: 1,
    text: 'Hörsch mol zue…',
    subtext: 'Des isch koi normaler Gutschein.',
    showCharacters: false,
    showBoat: false
  },
  {
    id: 2,
    text: 'Deine Eltern…',
    subtext: 'Die schwimme scho lang im Alltag rum.',
    showCharacters: true,
    showBoat: false
  },
  {
    id: 3,
    text: 'Aber jetzt…',
    subtext: 'Kommt was Besseres als Schwimme.',
    showCharacters: true,
    showBoat: true
  },
  {
    id: 4,
    text: 'Ein Boot!',
    subtext: '3 Stunde uff deiner Insel dohanna. Kapitän sein.',
    showCharacters: true,
    showBoat: true
  },
  {
    id: 5,
    text: 'Fast...',
    subtext: 'Erscht mussch des G\'schenk freischalte!',
    showCharacters: false,
    showBoat: true,
    fakeOut: true
  },
  {
    id: 6,
    text: 'OKAY JETZT!',
    subtext: 'Babbel net lang – los geht\'s!',
    showCharacters: false,
    showBoat: false,
    isFinal: true
  }
];

// Wizard step labels
export const WIZARD_STEPS = [
  { id: 'boat', label: 'Boot', emoji: '⛵' },
  { id: 'location', label: 'Ort', emoji: '📍' },
  { id: 'date', label: 'Datum', emoji: '📅' },
  { id: 'time', label: 'Zeit', emoji: '🕐' },
  { id: 'people', label: 'Lüt', emoji: '👥' },
  { id: 'addon', label: 'Extra', emoji: '🎁' },
  { id: 'wish', label: 'Wunsch', emoji: '✨' }
];

// UI Texts (Badisch dialect)
export const TEXTS = {
  unlockTitle: 'Fang des Boot!',
  unlockSubtitle: 'Tipp drauf bevor\'s abhaut!',
  unlockSuccess: 'G\'schenk freigschaltet!',
  unlockHint: 'Schneller!',
  
  boatStepTitle: 'Was für\'s Boot?',
  boatStepSubtitle: 'Such dir dei Schiff aus.',
  
  dateStepTitle: 'Wann soll\'s sei?',
  dateStepSubtitle: 'Mindestens 48 Stund vorher, gell.',
  
  timeStepTitle: 'Um wieviel Uhr?',
  timeStepSubtitle: 'Wähl dei Startzeit.',
  
  peopleStepTitle: 'Wieviel Lüt?',
  peopleStepSubtitle: 'Deine Eltern + Gäscht.',
  
  addonStepTitle: 'Nö. Extra Spaß?',
  addonStepSubtitle: 'Wakeboard, Ring, oder nix?',
  
  wishStepTitle: 'Sonsch no was?',
  wishStepSubtitle: 'Nö. I will ebbes anderscht:',
  wishPlaceholder: 'Z.B. Champagner, Geburtstagsdeko...',
  
  summaryTitle: 'Guat gmacht!',
  summarySubtitle: 'Jetzt wird g\'schippert.',
  
  sendButton: 'Per Mail abschicke',
  restartButton: 'Nochmal!',
  nextButton: 'Weiter',
  backButton: 'Zruck',
  
  durationLabel: 'Dauer',
  durationValue: '3 Stunde',
  
  locationStepTitle: 'Wo soll\'s losgeh?',
  locationStepSubtitle: 'Wähl dei Abfahrtsort uff Zypern.',
  
  steerGameTitle: 'Gell, net in d\'Welle!',
  steerGameSubtitle: 'Wisch links/rechts - halt des Boot 10 Sekunde zwischen de Welle!',
  steerGameSuccess: 'Kapitän-Material!',
  steerGameFail: 'Ups, abgsoffe!'
};

// Generate email content
export const generateEmailContent = (selections) => {
  const boat = BOAT_TYPES[selections.boatType];
  const addon = ADDONS.find(a => a.id === selections.addon);
  const location = LOCATIONS.find(l => l.id === selections.location);
  
  const subject = encodeURIComponent('Bootsgutschein Anfrage 🚤');
  
  const body = encodeURIComponent(`Hallo!

Ich möchte einen Bootsgutschein anfragen:

🚤 Boot: ${boat.name} (${boat.tagline})
📍 Ort: ${location?.name || 'Nicht gewählt'}
📅 Datum: ${selections.date}
🕐 Zeit: ${selections.time}
👥 Personen: ${selections.people}
⏱️ Dauer: 3 Stunden
🎁 Extra: ${addon.name}
${selections.customWish ? `✨ Besonderer Wunsch: ${selections.customWish}` : ''}

Bitte um Rückmeldung!

Danke & Gruß`);

  return `mailto:${TARGET_EMAIL}?subject=${subject}&body=${body}`;
};
